import { render, staticRenderFns } from "./ActiveAccidents.vue?vue&type=template&id=438afd54&scoped=true"
import script from "./ActiveAccidents.vue?vue&type=script&lang=js"
export * from "./ActiveAccidents.vue?vue&type=script&lang=js"
import style0 from "./ActiveAccidents.vue?vue&type=style&index=0&id=438afd54&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438afd54",
  null
  
)

export default component.exports